import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import Home from '@/pages/index_header.vue'
import Index from '@/pages/index.vue'
import Cardano from '@/pages/cardano.vue'
import Tron from '@/pages/tron.vue'
import IRISnet from '@/pages/iriSnet.vue'
import Certik from '@/pages/certik.vue'
import Gravity from '@/pages/gravity.vue'
import ROSE from '@/pages/oasisNetwork.vue'
import HowItWorks from '@/pages/how_it_works.vue'
import Mission from '@/pages/sustainable_future'
import Tezos from '@/pages/tezos.vue'
import Near from '@/pages/near.vue'
// import Solana from '@/pages/solana.vue'
import StakingFund from '@/pages/staking_fund.vue'
import Rewards from '@/pages/rewards.vue'
import CardanoReward02 from '@/pages/cardano_reward_02.vue'
import SolanaReward from '@/pages/solana_reward.vue'
import Terra from '@/pages/Terra.vue'
import Kava from '@/pages/kava.vue'
import Akash from '@/pages/akash.vue'
import Umee from '@/pages/umee.vue'
import Sentinel from '@/pages/sentinel.vue'
import Sommelier from '@/pages/sommelier.vue'
import FetchAi from '@/pages/fetchai.vue'
import Juno from '@/pages/juno.vue'
import RegenNetwork from '@/pages/regen_network.vue'
import QuicksilverZone from '@/pages/quicksilver.vue'
import XPLA from '@/pages/xpla.vue'
import Injective from '@/pages/injective.vue'
import Persistence from '@/pages/persistence.vue'
import Provenance from '@/pages/provenance.vue'
import Stargaze from '@/pages/stargaze.vue'
import Comdex from '@/pages/comdex.vue'
import Evmos from '@/pages/evmos.vue'
import Cudos from '@/pages/cudos.vue'
import Osmosis from '@/pages/osmosis.vue'
import Cronos from '@/pages/cronos.vue'
// import Campaigns from '@/pages/campaigns.vue'
// import BAND from '@/pages/bandProtocol.vue'

Vue.use(Router)
Vue.use(Meta)
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      children: [
        {
          path: '/',
          name: 'index',
          component: Index
        },
        // {
        //   path: '/campaign',
        //   name: 'campaigns',
        //   component: Campaigns
        // },
        {
          path: '/cardano-rewards-01',
          name: 'rewards',
          component: Rewards
        },
        {
          path: '/cardano-summer-staking-rewards',
          name: 'cardanoReward02',
          component: CardanoReward02
        },
        {
          path: '/solana-staking-rewards-01',
          name: 'solanaReward',
          component: SolanaReward
        },
        {
          path: '/how-it-works',
          name: 'how_it_works',
          component: HowItWorks
        },
        {
          path: '/mission',
          name: 'mission',
          component: Mission
        },
        {
          path: '/staking-fund',
          name: 'stakingFund',
          component: StakingFund
        },
        {
          path: '/cardano-staking',
          name: 'cardano',
          component: Cardano
        },
        {
          path: '/tron-staking',
          name: 'tron',
          component: Tron
        },
        {
          path: '/irisnet-staking',
          name: 'IRISnet',
          component: IRISnet
        },
        {
          path: '/certik-staking',
          name: 'Certik',
          component: Certik
        },
        {
          path: '/gravity-bridge-staking',
          name: 'Gravity',
          component: Gravity
        },
        {
          path: '/oasis-network-staking',
          name: 'ROSE',
          component: ROSE
        },
        {
          path: '/tezos-staking',
          name: 'Tezos',
          component: Tezos
        },
        {
          path: '/near-staking',
          name: 'Near',
          component: Near
        },
        {
          path: '/terra-classic-staking',
          name: 'Terra',
          component: Terra
        },
        {
          path: '/kava-staking',
          name: 'Kava',
          component: Kava
        },
        {
          path: '/akash-network-staking',
          name: 'Akash',
          component: Akash
        },
        {
          path: '/umee-staking',
          name: 'Umee',
          component: Umee
        },
        {
          path: '/sentinel-staking',
          name: 'Sentinel',
          component: Sentinel
        },
        {
          path: '/sommelier-staking',
          name: 'Sommelier',
          component: Sommelier
        },
        {
          path: '/fetch-ai-staking',
          name: 'FetchAi',
          component: FetchAi
        },
        {
          path: '/juno-staking',
          name: 'Juno',
          component: Juno
        },
        {
          path: '/regen-network-staking',
          name: 'RegenNetwork',
          component: RegenNetwork
        },
        {
          path: '/quicksilver-zone-staking',
          name: 'QuicksilverZone',
          component: QuicksilverZone
        },
        {
          path: '/xpla-staking',
          name: 'XPLA',
          component: XPLA
        },
        {
          path: '/injective-staking',
          name: 'Injective',
          component: Injective
        },
        {
          path: '/persistence-staking',
          name: 'Persistence',
          component: Persistence
        },
        {
          path: '/provenance-staking',
          name: 'Provenance',
          component: Provenance
        },
        {
          path: '/stargaze-staking',
          name: 'Stargaze',
          component: Stargaze
        },
        {
          path: '/comdex-staking',
          name: 'Comdex',
          component: Comdex
        },
        {
          path: '/evmos-staking',
          name: 'Evmos',
          component: Evmos
        },
        {
          path: '/cudos-staking',
          name: 'Cudos',
          component: Cudos
        },
        {
          path: '/osmosis-staking',
          name: 'Osmosis',
          component: Osmosis
        },
        {
          path: '/cronos-staking',
          name: 'Cronos',
          component: Cronos
        }
        // {
        //   path: '/solana-staking',
        //   name: 'Solana',
        //   component: Solana
        // }
        // {
        //   path: '/Band-Protocol-staking',
        //   name: 'BAND',
        //   component: BAND
        // }
      ]
    }
  ],
  // 配置滚动行为，跳转到新的路由界面滚动条的位置
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js